import { FormApi } from 'final-form';
import { observer } from 'mobx-react';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import isNil from 'ramda/src/isNil';
import { useCreateEditEventFlowStore } from '~admin/store/create-edit-event-flow-store-provider';
import { EventFormData } from '~admin/view/components/details/event-form-data';
import {
  AllocationTimeDetails,
  AllocationTimeDetailsFormData,
} from '~admin/view/components/details/marketplace-details/marketplace-datetime-details/allocation-time-details.component';
import {
  FixPaymentDetailsFormData,
  FixPaymentTimeDetails,
} from '~admin/view/components/details/marketplace-details/marketplace-datetime-details/fix-payment-time-details.component';
import { showFixPaymentFields } from '~admin/view/components/details/marketplace-details/marketplace-datetime-details/marketplace-datetime-details.helper';
import { DatetimeField } from '~admin/view/components/ui/form/fields/field-datetime.component';
import { Box } from '~common/components/box.component';
import { Column } from '~common/components/column.component';

interface Props {
  name: string;
  marketplaceIndex: number;
  form?: FormApi<EventFormData>;
}

export interface MarketplaceDatetimeFormData
  extends FixPaymentDetailsFormData,
    AllocationTimeDetailsFormData {
  startDateTime: string;
  endDateTime: string;
}

export const MarketplaceDatetimeDetails: React.FunctionComponent<Props> = observer(
  ({ name, marketplaceIndex, form }) => {
    const { t } = useTranslation();
    const createEventFlowStore = useCreateEditEventFlowStore();
    const { eventDateTimeStart, eventDateTimeEnd } = createEventFlowStore.eventDates;
    const { startDateTime, endDateTime, type } = createEventFlowStore.marketplaces[
      marketplaceIndex
    ];

    useEffect((): void => {
      // TODO(Dmitry): https://github.com/final-form/react-final-form/issues/686
      // Known issue that there is a conflict b/w initialValues of the form and initialValue of the array field
      if (isNil(startDateTime) || isNil(endDateTime)) {
        form?.change(`${name}.startDateTime` as keyof EventFormData, eventDateTimeStart);
        form?.change(`${name}.endDateTime` as keyof EventFormData, eventDateTimeEnd);
      }
    }, []);

    return (
      <Container>
        <Row>
          <RestrictBox>
            <DatetimeField
              name={`${name}.startDateTime`}
              label={t('createEvent.marketplaceDetails.dateTime.startDateTime')}
            />
          </RestrictBox>
          <RestrictBox>
            <DatetimeField
              name={`${name}.endDateTime`}
              label={t('createEvent.marketplaceDetails.dateTime.endDateTime')}
            />
          </RestrictBox>
        </Row>
        {showFixPaymentFields(type) && <FixPaymentTimeDetails name={name} />}
        <AllocationTimeDetails name={name} type={type} />
      </Container>
    );
  },
);

const Container = styled(Column)`
  flex: 1 1 auto;

  > div:not(:first-child) {
    margin-top: 16px;
  }
`;

const Row = styled(Box)`
  margin-top: 12px;
  > div:not(:first-child) {
    margin-left: 50px;
  }
`;

const RestrictBox = styled(Box)`
  flex: 1 1 auto;
  margin: 0 12px;
`;



// WEBPACK FOOTER //
// ./view/components/details/marketplace-details/marketplace-datetime-details.component.tsx